<div class="mt-2 col-md-12">
  <div class="d-flex align-items-center">
    <div>
      <p>Name: <span class="bold">{{organization.organization_name}}</span></p>
      <p>Id: {{organization.organization_id}}</p>
    </div>
    <div class="ml-3">
      <app-button
        (click)="editOrganization()"
        [submit]="false">Edit</app-button>
    </div>
    <div class="ml-3">
      <app-button
        (click)="deleteOrganization()"
        [buttonStyle]="'danger'"
        [submit]="false">Delete</app-button>
    </div>
  </div>
</div>
